<template>
  <div class="bto-sb-widget bto-sb-widget-prematch"
    :class="useLatam ? 'bto-sb-widget-prematch-3w' : 'bto-sb-widget-prematch-full-view'">
    <!-- tab title -->
    <div class="bto-sb-widget-title bto-sb-widget-nav-icon">
      <h3 v-if="!isCategoryList">{{sport.tabs[tabIdx].categoryName}}{{sport.tabs[tabIdx].tournamentName ? ` > ${sport.tabs[tabIdx].tournamentName}` : ''}}</h3>
      <h3 v-if="isCategoryList">{{sport.tabs[tabIdx].tournamentName ? `${sport.tabs[tabIdx].tournamentName}` : ''}}</h3>
      <ul class="bto-sb-widget-nav-icon" v-if="!isCategoryList">
        <li v-if="showPrintButton"><a href="javascript:void(0);" title="Print" class="bto-sb-widget-nav-icon-print" @click="goToCategoryPrintPage()"></a></li>
        <li v-if="SHOW_FAVORITES">
          <ToggleFavoriteComponent
            :favType="3"
            :sport="sport"
            :tournament="sport.tabs[tabIdx]"/>
        </li>
        <li><a href="javascript:void(0);" :title="t('Global.Collapse')" :class="tabCollapsed ? 'bto-sb-widget-nav-icon-expand' : 'bto-sb-widget-nav-icon-collapse'" @click="toggleCollapse()"></a></li>
        <li><a href="javascript:void(0);" :title="t('Public.Close')" class="bto-sb-widget-nav-icon-close" @click="closeTournamentTab()"></a></li>
      </ul>
      <ul class="bto-sb-widget-nav-icon" v-else-if="isCategoryList && SHOW_FAVORITES">
        <li>
          <ToggleFavoriteComponent
            :favType="3"
            :sport="sport"
            :tournament="sport.tabs[tabIdx]"/>
        </li>
      </ul>
    </div>
    <!-- tab markets -->
    <category-market-selector-component
      v-show="!tabCollapsed && markets.length > 0 && !isCategoryList"
      :markets="markets"
      :sportName="sport.name"
      :singleMarketSelected="singleMarketSelected"
      :marketTabSelectHandler="marketTabSelectHandler"
    />
    <!-- tab odds -->
    <div v-show="!tabCollapsed" class="bto-sb-widget-content">
      <!-- odds nav -->
      <div class="bto-sb-event-odds-nav" v-if="!useLatam">
        <!-- dropdowns -->
        <div class="bto-sb-event-odds-nav-control">
          <div class="bto-sb-event-odds-left" v-if="!isCategoryList">
            <div class="bto-sb-event-odds-cell bto-sb-event-odds-categoryname">{{sport.tabs[tabIdx].tournamentName}}</div>
          </div>
          <div v-if="!singleMarketSelected" class="bto-sb-event-odds-right">
            <div :class="['bto-sb-event-odds-cell',
              is3WaySportMatch ? 'bto-sb-event-odds-3way' : 'bto-sb-event-odds-2way']">
              {{t(is3WaySportMatch ? 'W.M.3Way' : 'W.M.2Way')}}
            </div>
            <div
              v-if="Object.keys(sport.combiMainMarkets).length && sport.combiMainMarkets.hasOwnProperty(1)"
              class="bto-sb-event-odds-cell bto-sb-md-none">
              <div class="bto-sb-form-select">
                <select
                  v-model="firstCombiSelected"
                  @change="combiChange(1)">
                  <option
                    v-for="(option, idx) in sport.combiMainMarkets[1]"
                    :key="idx"
                    :value="option.n">
                    {{t(option.n)}}
                  </option>
                </select>
                <div class="bto-sb-form-select-arrow"></div>
              </div>
            </div>
            <div
              v-if="Object.keys(sport.combiMainMarkets).length && sport.combiMainMarkets.hasOwnProperty(2)"
              class="bto-sb-event-odds-cell bto-sb-lg-none">
              <div class="bto-sb-form-select">
                <select
                  v-model="secondCombiSelected"
                  @change="combiChange(2)">
                  <option
                    v-for="(option, idx) in sport.combiMainMarkets[2]"
                    :key="idx"
                    :value="option.n">
                    {{t(option.n)}}
                  </option>
                </select>
                <div class="bto-sb-form-select-arrow"></div>
              </div>
            </div>
            <div class="bto-sb-event-odds-cell bto-sb-event-morelabel-odds"></div>
          </div>
        </div>

        <!-- header text -->
        <div class="bto-sb-event-odds-nav-labels">
          <div class="bto-sb-event-odds-left">
            <div v-if="showEventCode" class="bto-sb-event-odds-cell bto-sb-event-codelabel">{{t('Public.Code')}}</div>
            <div class="bto-sb-event-odds-cell bto-sb-event-timelabel">{{t('Public.Time')}}</div>
            <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">{{t('Public.Event')}}</div>
          </div>
          <div class="bto-sb-event-odds-right">
            <div class="bto-sb-event-odds-cell" v-if="!singleMarketSelected">
              <span class="bto-sb-event-marketlabel">{{t('Mobile.outcome1name')}}</span>
              <span v-if="is3WaySportMatch" class="bto-sb-event-marketlabel">{{t('Mobile.outcomexname')}}</span>
              <span class="bto-sb-event-marketlabel">{{t('Mobile.outcome2name')}}</span>
            </div>
            <div
              v-if="!singleMarketSelected && Object.keys(sport.combiMainMarkets).length && sport.combiMainMarkets.hasOwnProperty(1)"
              class="bto-sb-event-odds-cell bto-sb-md-none">
              <span v-if="Object.values(firstCombiOdds).find(o => o && o.outcomes.find(o => o.sbv))" class="bto-sb-event-marketlabel"></span>
              <span
                class="bto-sb-event-marketlabel"
                v-for="(oddType, idx) in sortedComboSelection(1)"
                :key="idx">
                {{t(oddType.n)}}
              </span>
            </div>
            <div
              v-if="!singleMarketSelected && Object.keys(sport.combiMainMarkets).length && sport.combiMainMarkets.hasOwnProperty(2)"
              class="bto-sb-event-odds-cell bto-sb-lg-none">
              <span v-if="Object.values(secondCombiOdds).find(o => o && o.outcomes.find(o => o.sbv))" class="bto-sb-event-marketlabel"></span>
              <span
                class="bto-sb-event-marketlabel"
                v-for="(oddType, idx) in sortedComboSelection(2)"
                :key="idx">
                {{t(oddType.n)}}
              </span>
            </div>
            <div class="bto-sb-event-odds-cell bto-sb-event-morelabel-odds">{{t('Mobile.more')}}</div>
          </div>
        </div>
      </div>
      <div class="bto-sb-event-odds-content">
        <!-- odds list -->
        <match-list-item-component
          v-for="(match, idx) in filledMatchList"
          :key="idx"
          :is3WaySport="is3WaySportMatch"
          :match="match"
          :useLatam="useLatam"
          :singleMarketSelected="singleMarketSelected"
          :singleMarketOdds="singleMarketOdds[match.matchId]"

          :combiMainMarkets="sport.combiMainMarkets"
          :firstCombiSelected="firstCombiSelected"
          :secondCombiSelected="secondCombiSelected"
          :firstCombiOdds="firstCombiOdds"
          :secondCombiOdds="secondCombiOdds"
          :showFavorites="SHOW_FAVORITES"
        />
        <!-- legend -->
        <combinability-legend-component v-if="SHOW_LEGEND" />
      </div>
    </div>
  </div>
</template>

<script>
  import CategoryMarketSelectorComponent from './component-category-market-selector';
  import { SingleMarketOddsRequestService } from './service-single-market-odds';
  import ChangeCombiService from '../../../services/changeCombi-request-service';
  import MatchDetailsOddModel from '../match-details/common/model-match-details-odd';
  import MatchDetailsOutcomeModel from '../match-details/common/model-match-details-outcome';
  import MatchListItemComponent from './component-match-list-item';
  import CombinabilityLegendComponent from '../../shared/combinability-legend-component';
  import { EventBus } from '../../../services/event-bus-service';
  import OddHelperService from '../../../services/odd-helper-service';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import ToggleFavoriteComponent from '../../common/toggle-favorite-component';

  export default {
    name: 'CategoryTabComponent',
    components: {
      CategoryMarketSelectorComponent,
      MatchListItemComponent,
      CombinabilityLegendComponent,
      ToggleFavoriteComponent
    },
    data() {
      return {
        tabCollapsed: false,
        singleMarketSelected: null,
        singleMarketOdds: {},
        firstCombiSelected: undefined,
        secondCombiSelected: undefined,
        firstCombiId: undefined,
        secondCombiId: undefined,
        changedFirstCombOdds: {},
        changedSecondCombOdds: {},
        showEventCode: APP_SETTINGS.category.showEventCode,
        SHOW_LEGEND: APP_SETTINGS.category.showCombinabilityLeg,
        SHOW_FAVORITES: APP_SETTINGS.category.showFavorites,
        showPrintButton: APP_SETTINGS.category.showPrintFixture,
      };
    },
    props: {
      sportIn: {
        type: Object,
        required: true,
        default: () => { },
      },
      tabIdx: {
        type: Number,
        required: true,
        default: null,
      },
      is3WaySport: {
        type: Boolean,
        required: true,
        default: false,
      },
      markets: {
        type: Array,
        required: true,
        default: () => [],
      },
      isCategoryList: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      this.fillCombis();
    },
    watch: {
      sport() {
        this.singleMarketSelected = null;
        this.singleMarketOdds = {};
        this.fillCombis();
      }
    },
    computed: {
      sport() {
        return this.sportIn;
      },
      is3WaySportMatch() {
        return this.sport.tabs[this.tabIdx].is3way;
      },
      filledMatchList() {
        return this.sport.tabs[this.tabIdx].matches.map(m => ({
          ...m,
          categoryName: this.sport.tabs[this.tabIdx].categoryName,
          tournamentName: this.sport.tabs[this.tabIdx].tournamentName,
        }));
      },
      useLatam() {
        if (this.singleMarketSelected) {
          return false;
        }
        return APP_SETTINGS.settings.layout === LAYOUT_NAME.LATAM;
      },
      firstCombiOdds() {
        if (typeof this.firstCombiId === 'undefined') {
          return {};
        }
        let combiOdds = {};
        this.sport.tabs[this.tabIdx].matches.forEach(match => {
          if (Object.keys(this.changedFirstCombOdds).length > 0 &&
            typeof this.changedFirstCombOdds[match.matchId] !== 'undefined' &&
            this.changedFirstCombOdds[match.matchId].marketId === this.firstCombiId) {
            combiOdds[match.matchId] = this.changedFirstCombOdds[match.matchId];
          } else {
            combiOdds[match.matchId] = match.odds.find(odd => odd.marketId === this.firstCombiId) || this.generateEmptyOutcomes(this.firstCombiId, 1);
          }
        });
        return combiOdds;
      },
      secondCombiOdds() {
        if (typeof this.secondCombiId === 'undefined') {
          return {};
        }
        let combiOdds = {};
        this.sport.tabs[this.tabIdx].matches.forEach(match => {
          if (Object.keys(this.changedSecondCombOdds).length > 0 &&
            typeof this.changedSecondCombOdds[match.matchId] !== 'undefined' &&
            this.changedSecondCombOdds[match.matchId].marketId === this.secondCombiId) {
            combiOdds[match.matchId] = this.changedSecondCombOdds[match.matchId];
          } else {
            combiOdds[match.matchId] = match.odds.find(odd => odd.marketId === this.secondCombiId) || this.generateEmptyOutcomes(this.secondCombiId, 2);
          }
        });
        return combiOdds;
      },
    },
    methods: {
      fillCombis() {
        if (this.sport.combiMainMarkets && typeof this.sport.combiMainMarkets === 'object' && Object.keys(this.sport.combiMainMarkets).length) {
          let firstCombiInJSON = this.sport.combiMainMarkets.hasOwnProperty(1) ? this.sport.combiMainMarkets[1][0] : {};
          let secondCombiInJSON = this.sport.combiMainMarkets.hasOwnProperty(2) ? this.sport.combiMainMarkets[2][0] : {};

          this.firstCombiSelected = firstCombiInJSON ? firstCombiInJSON.n : undefined;
          this.secondCombiSelected = secondCombiInJSON ? secondCombiInJSON.n : undefined;
          // fill combi odds
          this.firstCombiId = firstCombiInJSON ? firstCombiInJSON.ot : undefined;
          this.secondCombiId = secondCombiInJSON ? secondCombiInJSON.ot : undefined;
        }
      },
      toggleCollapse() {
        this.tabCollapsed = !this.tabCollapsed;
      },
      marketTabSelectHandler(marketId) { // market select change
        this.singleMarketSelected = marketId;
        if (!marketId) {
          return;
        }
        let singleMarketOddsRequest = new SingleMarketOddsRequestService();
        let tournamentGroupData = [];
        let tournamentData = [];

        if (this.sport.tabs[this.tabIdx].isGroup) {
          tournamentGroupData = [this.sport.tabs[this.tabIdx].id];
        } else {
          tournamentData = [this.sport.tabs[this.tabIdx].id];
        }

        singleMarketOddsRequest.getParams.oddTypeIDs = [marketId];
        singleMarketOddsRequest.getParams.TournamentData = tournamentData;
        singleMarketOddsRequest.getParams.TournamentGroupData = tournamentGroupData;

        singleMarketOddsRequest.execute((response) => {
          let tournamentId = this.sport.tabs[this.tabIdx].id;
          if (!response.data) {
            // console.warn('no odds for this market...');
            this.singleMarketOdds = {};
            return;
          }
          const responseKeys = Object.keys(response.data);
          let responseObj = {};
          if (responseKeys.length > 1 || this.sport.tabs[this.tabIdx].isGroup) {
            responseObj = Object.assign({}, ...responseKeys.map(k => response.data[k]));
          } else {
            responseObj = response.data[tournamentId];
          }
          let singleMarketOdds = {};
          Object.entries(responseObj).map(([matchId, matchOdds]) => {
            let odd = matchOdds[0];
            singleMarketOdds[matchId] = new MatchDetailsOddModel(odd);
            singleMarketOdds[matchId].outcomes = odd.m.map(m => new MatchDetailsOutcomeModel(m));
          });

          this.singleMarketOdds = singleMarketOdds;
        }, (error) => {
          console.error(error); // eslint-disable-line
        });
      },
      combiChange(n) { // odds nav dropdown change
        let combiRequest = new ChangeCombiService();
        let matchIds = this.sport.tabs[this.tabIdx].matches.map(m => m.matchId);
        combiRequest.getParams.MatchData = matchIds;

        let selectedCombi = n === 1 ? this.firstCombiSelected : this.secondCombiSelected;
        let combiMarket = this.sport.combiMainMarkets[n].find(x => x.n === selectedCombi);
        combiRequest.getParams.OddType = combiMarket.ot;
        combiRequest.getParams.Outcomes = combiMarket.o.map(o => o.id);
        combiRequest.getParams.isMostBalanced = combiMarket.mb;

        if (combiRequest.getParams.Outcomes.indexOf(null) > -1) {
          delete combiRequest.getParams.Outcomes;
        }

        combiRequest.execute((response) => {
          let changedCombiOdds = {};
          this.sport.tabs[this.tabIdx].matches.forEach((match) => {
            if (!response.data || !response.data.hasOwnProperty(match.matchId)) {
              changedCombiOdds[match.matchId] = this.generateEmptyOutcomes(combiRequest.getParams.OddType, n);
            } else {
              let odd = response.data[match.matchId][0];
              changedCombiOdds[match.matchId] = new MatchDetailsOddModel(odd, match.homeTeam, match.guestTeam);
              changedCombiOdds[match.matchId].outcomes = odd.m.map(m => new MatchDetailsOutcomeModel(m, match.homeTeam, match.guestTeam));
            }
          });
          if (n === 1) {
            this.changedFirstCombOdds = changedCombiOdds;
            this.firstCombiId = combiRequest.getParams.OddType;
          } else if (n === 2) {
            this.changedSecondCombOdds = changedCombiOdds;
            this.secondCombiId = combiRequest.getParams.OddType;
          }
        }, (error) => {
          console.error(error); // eslint-disable-line
        });
      },
      goToCategoryPrintPage() {
        EventBus.$emit('openCategoryPrintPage', this.sport.tabs[this.tabIdx]);
      },
      closeTournamentTab() {
        EventBus.$emit('closeTournamentTab', this.sport.tabs[this.tabIdx].id);
      },
      generateEmptyOutcomes(oddTypeID, mainCombiIndex) {
        let combiMarket = this.sport.combiMainMarkets[mainCombiIndex] && this.sport.combiMainMarkets[mainCombiIndex].find(x => x.ot === oddTypeID);
        let emptyOdd = {
          c: 0,
          id: oddTypeID,
          n: '',
        };
        let combiOdd = new MatchDetailsOddModel(emptyOdd);
        if (typeof combiMarket !== 'undefined' && typeof combiMarket.o !== 'undefined') {
          combiOdd.outcomes = OddHelperService.generateEmptyOutcomes(combiMarket.o.length, false).outcomes;
          if (combiMarket.sbv || combiMarket.mb) {
            combiOdd.outcomes[0].sbv = '--';
          }
        }
        return combiOdd;
      },
      /**
       * Sort selected combos according to column id
       * @param {1|2} comboIdx - Index of combos (1 or 2)
       */
      sortedComboSelection(comboIdx) {
        const comboSelection = comboIdx === 1 ? this.firstCombiSelected : this.secondCombiSelected;
        const allComboMarkets = this.sport.combiMainMarkets[comboIdx] || [];
        const comboMarkets = (allComboMarkets.find(c => c.n === comboSelection) || {}).o || [];
        return [...comboMarkets].sort((a, b) => (a.cid - b.cid));
      },
    },
  };
</script>
